const MutualHelp = () =>
  import(
    /* webpackChunkName: "mutualHelp~index" */ 'page/platform/mutualHelp/index.vue'
  )
const bookClub = () =>
  import(
    /* webpackChunkName: "mutualHelp~index" */ 'page/platform/mutualHelp/bookClub.vue'
  )

const MutualHelpV3 = () =>
  import(
    /* webpackChunkName: "mutualHelp~index~v3" */ 'page/platform/mutualHelp/index_v3.vue'
  )

let routes = [
  {
    path: '/mutualHelp/index',
    component: MutualHelp,
    meta: {
      pageName: '互助首页',
      business: '平台',
      title: '互助首页'
    }
  },
  {
    path: '/mutualHelp/bookClub',
    component: bookClub,
    meta: {
      pageName: '书友伴读',
      business: '平台',
      title: '书友伴读'
    }
  },
  {
    path: '/mutualHelp/index_v3',
    component: MutualHelpV3,
    meta: {
      pageName: '互助首页',
      business: '平台',
      title: '互助首页'
    }
  }
]

export default routes
